import api from './api';
import { LeaveType, CreateLeaveTypeData, UpdateLeaveTypeData } from '../types/leaveType';

export const leaveTypeService = {
  // 休暇種別一覧取得
  async getAll(includeInactive = false): Promise<LeaveType[]> {
    const params = includeInactive ? { include_inactive: 'true' } : {};
    const response = await api.get('/leave-types', { params });
    return response.data;
  },

  // 休暇種別作成
  async create(data: CreateLeaveTypeData): Promise<LeaveType> {
    const response = await api.post('/leave-types', data);
    return response.data;
  },

  // 休暇種別更新
  async update(id: number, data: UpdateLeaveTypeData): Promise<LeaveType> {
    const response = await api.put(`/leave-types/${id}`, data);
    return response.data;
  },

  // 休暇種別削除
  async delete(id: number): Promise<void> {
    await api.delete(`/leave-types/${id}`);
  },
};
